import { Container } from '@/components';
import { ROUTES, RouteName } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { type IHeader, ResponsiveCollection } from '@/interfaces';
import { getPmtLangHref, gtmClickPmc } from '@/utils';
import Image from 'next/image';
import Link from 'next/link';
import type React from 'react';
import CollapseNavigation from './CollapseNavigation';
import DropdownNavigation from './DropdownNavigation';
import {
  ExploreCommunityButton,
  ExploreCommunityLink,
  HeaderContent,
  HeaderWrapper,
  Logo,
  ParcelMonitorLogo,
} from './Header.styles';
import Languages from './Languages';
import Profile from './Profile';

const Header: React.FC<IHeader & { onlyLogo?: boolean }> = (props) => {
  const { itemList, button, onlyLogo } = props;

  const { isDesktopPMT, isTablet } = useResponsive([ResponsiveCollection.DesktopPMT, ResponsiveCollection.Tablet]);

  const { pmtCurrentLanguageCode, isMyParcelsPage } = useGlobalState();

  const DEFAULT_BUTTON_TEXT = 'EXPLORE THE COMMUNITY';

  const TrackingHeader = (
    <>
      <a href={getPmtLangHref(pmtCurrentLanguageCode)}>
        <ParcelMonitorLogo />
      </a>
      {isDesktopPMT ? (
        <>
          <Languages />
          <Profile />
          <ExploreCommunityLink href='/' target='_blank' onClick={() => gtmClickPmc('/')}>
            <ExploreCommunityButton truncate isPMTButton>
              {button || DEFAULT_BUTTON_TEXT}
            </ExploreCommunityButton>
          </ExploreCommunityLink>
        </>
      ) : (
        <>
          <Profile />
          <CollapseNavigation {...props} />
        </>
      )}
    </>
  );

  const CommunityHeader = (
    <>
      <Link href={ROUTES[RouteName.Home].path ?? '#'} passHref>
        <Logo>
          <Image src='/images/icons/monitor_logo.svg' alt='Parcel Monitor Logo' fill sizes='100vw' />
        </Logo>
      </Link>
      {!onlyLogo && (
        <>
          {!isTablet && <DropdownNavigation itemList={itemList} />}
          <Profile />
          {isTablet && <CollapseNavigation itemList={itemList} />}
        </>
      )}
    </>
  );

  return (
    <HeaderWrapper id='header'>
      <Container>
        <HeaderContent>{isMyParcelsPage ? TrackingHeader : CommunityHeader}</HeaderContent>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
